import PropTypes from 'prop-types'
import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/regular/eye.svg'
import BaseIcon from '../../BaseIcon'

const Eye = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 576 512" />
}

Eye.propTypes = {
	className: PropTypes.string,
}

export default Eye
